export const SLICE_NAME = 'square';
